import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, DatePicker } from 'antd';
import moment from 'moment';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = (props) => {
  const { dataSource } = props;

  const {
    name,
    start,
    cycle
  } = dataSource;

  return {
    name: Form.createFormField({ value: name }),
    start: Form.createFormField({ value: start ? moment(start) : null }),
    cycle: Form.createFormField({ value: cycle })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inputFormItemLayout, form
}) => {
  const { getFieldDecorator } = form;
  const {
    name,
    start,
    cycle
  } = dataSource;

  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {getFieldDecorator('name', {
          initialValue: name,
          rules: [{
            required: true,
            message: 'Please enter the Roster builder name.'
          }]
        })(<Input disabled={readonly} />)}
      </FormItem>

      <FormItem {...inputFormItemLayout} label="Start Date">
        {getFieldDecorator('start', {
           initialValue: start ? moment(start) : null
          })(
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              format="DD-MM-YYYY HH:mm"
              placeholder="Start date"
              disabled
            />
        )}
      </FormItem>

      <FormItem {...inputFormItemLayout} label="Cycle">
        {getFieldDecorator('cycle', {
          initialValue: cycle || null,
        })(<Input disabled />)}
      </FormItem>

    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const RosterBuilderFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default RosterBuilderFormInput;
